import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * ラジオボタン コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const Radio = (props) => {
    const { checked = undefined, className = '', disabled = false, id = undefined, inputProps = {}, isError = false, label = '', name = undefined, onChange = () => { }, readOnly = false, required = false, value, } = props;
    const isDisabled = disabled || readOnly;
    const boxBorderColor = useMemo(() => ({
        'border-gray-400': !checked || (checked && isDisabled),
        'border-navy-100': checked && !isDisabled && !isError,
        'border-red-100': !isDisabled && isError,
    }), [checked, isDisabled, isError]);
    const checkBgColor = useMemo(() => ({
        'bg-gray-400': checked && isDisabled,
        'bg-gray-50': !checked,
        'bg-navy-100': checked && !isDisabled && !isError,
        'bg-red-100': checked && !isDisabled && isError,
    }), [checked, isDisabled, isError]);
    return (_jsxs("label", Object.assign({ className: clsx('group', 'inline-flex flex-nowrap items-center gap-x-8', isDisabled ? 'hover:cursor-not-allowed' : 'hover:cursor-pointer', className) }, { children: [_jsx("input", Object.assign({}, inputProps, { checked: checked, className: 'hidden', disabled: disabled, id: id, name: name, onChange: onChange, readOnly: readOnly, required: required, type: 'radio', value: value })), _jsxs("span", Object.assign({ className: clsx('inline-block', 'shrink-0', 'relative', 'w-[20px] h-[20px]') }, { children: [_jsx("span", { className: clsx('block', 'w-[20px] h-[20px]', 'absolute top-0 left-0', 'border border-solid rounded-full', 'bg-gray-50', boxBorderColor, !isDisabled && !isError && 'group-hover:border-navy-100') }), _jsx("span", { className: clsx('block', 'absolute left-[4px] top-[4px]', 'w-[12px] h-[12px]', 'rounded-full', checkBgColor, checked ? 'opacity-100' : 'opacity-0') })] })), label && (_jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: label })))] })));
};
